import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=2242834c&scoped=true&"
import script from "./CheckboxView.vue?vue&type=script&lang=js&"
export * from "./CheckboxView.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxView.vue?vue&type=style&index=0&id=2242834c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242834c",
  null
  
)

export default component.exports